import { ServerSettingsPage } from "./ServerSettingsPage";

interface IDeletedProjects { deleted:string[]}

export class LQTS{

    
    constructor() {
        // Init code goes here

    }
    render() {

        let QMSProjects = ServerSettingsPage().settings().QMSProjects.sort();
       
        if (window["configApp"])
            return; //We are in admin so we don't do anything
        
        if (matrixSession.getProjectList(false).map(p => p.shortLabel).filter(o => QMSProjects.includes(o)).length > 0)
            return; // We have at least one of QMS project
        
        if (matrixSession.isSuperAdmin()) {
            $("#idProjectList").prepend($(`<li id="qmsItem" ><div style="display:hidden;width: 14px;float: left;/* margin: 3px; */margin-right: 5px;margin-left: 8px;border-radius: 4px;"> <div></div></div><span class="mainmenu">Unhide QMS</span></li>`).click(async () => {
               
                let failure = "";
                let restoredProjects = [];
                for (let newProject of QMSProjects) {
                    if (newProject) {
                        try {
                            await restConnection.putServer(newProject + "/unhide", { "reason": "unhide QMS projects", "newShort": newProject });
                            restoredProjects.push(newProject);
                        } catch {
                            failure += "Fail to restore" + newProject + "\r\n";
                        }
                    }
                }
                if (failure == "") {

                    let dlg:any = $("<div>").appendTo($("body"));
                    let ui = $("<div style='height:100%;width:100%'>These projects has been restored : " + restoredProjects.join(", ") +"<ul></ul></div>");

                    ml.UI.showDialog(dlg, "Projects restored", ui, 300,200,
                        [{
                            text: 'Verify Users Access',
                            class: 'btnCancel',
                            click: function () {
                                window.open( matrixBaseUrl + "/adminConfig/projectaccess")
                            }
                        }, {
                            text: 'Give W access to admin users',
                            class: 'btnDoIt',
                            click: async function () {
                                let userList:XRGetUser_AllUsers_GetUserListAck = <XRGetUser_AllUsers_GetUserListAck> await restConnection.getServer("user");
                                for (let user of userList.user)
                                {
                                    if (user.customerAdmin) {
                                        for (let project of restoredProjects) {
                                            let r = await restConnection.postServer("user/" + user.login + "/" + project, { permission: 2, reason: "Adding QMS" })
                                            console.log(user.login, project, r);
                                            $("ul", ui).append("<li>Granting W to <i>" + user.login + "</i> for <i>" + project + "</i>");
                                        }
                                            
                                    }
                                }
                                $(ui).append("<div> This page will refresh automatically in 5 seconds");
                                setTimeout(() =>{ window.location.href = matrixBaseUrl +  "/QMS"}, 5000);
                            }
                        }], UIToolsEnum.Scroll.Auto);
                  
                }
                else {
                    alert("Fail to restore projects : " + failure);
                }
            }));
        }
        // Always show QMS for support
        $("#idProjectList").prepend($(`<li><div style="display:hidden;width: 14px;float: left;/* margin: 3px; */margin-right: 5px;margin-left: 8px;border-radius: 4px;"> <div></div></div><span class="mainmenu">Request QMS projects</span></li>`).click(async () => {
            
            let currentUser:IUserGet = <IUserGet> await restConnection.getServer("user/" + matrixSession.getUser());
            ml.UI.showConfirm(-1, { title: "Please contact support to activate QMS projects.", ok: "Create a ticket automatically", }, () => {
            let param:IEmail = {
                summary: "Please activate QMS project on my instance."
                ,description: `The user ${matrixSession.getUser()} asked to activate QMS projects in the following instance : ${matrixBaseUrl} `
                ,matrixProject: "QMS"
                ,matrixItem: app.getCurrentItemId()
                ,browser: ""
                , log: ""
                , email: currentUser.email
            }
                
                let call_param: JQueryAjaxSettings = {
                    type: "POST",
                    url: matrixBaseUrl + "/rest/1/all/servicedesk", 
                    data: JSON.stringify(param),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function(data:any) {
                        if ( data.key )  {
                            ml.UI.showConfirm(-1, { title: "A ticket has been created : " +data.key, ok: "ok", }, () => {}, () => {});
                        } else {
                            ml.UI.showConfirm(-1, { title: data.message, ok: "ok", }, () => {}, () => {});
                            
                        }
                    },
                    error: function(errMsg) {
                         ml.UI.showConfirm(-1, { title: "Fail to create ticket : " + errMsg, ok: "ok", }, () => {
                        }, () => {
                        });
                    }
                }
                $.ajax(call_param);

            }, () => {
            });
        }));
    }
}